document.addEventListener('DOMContentLoaded', () => {
  // Solo en páginas donde tenga sentido (colecciones y búsqueda)
  const isCollection = window.location.pathname.includes('/collections/');
  const isSearch = window.location.pathname.includes('/search');

  if (!isCollection && !isSearch) return;

  const url = new URL(window.location.href);
  const params = url.searchParams;

  if (!params.has('filter.v.availability')) {
    params.set('filter.v.availability', '1');
    params.delete('page');
    url.search = params.toString();
    window.location.replace(url.toString());
  }
});
